import { useReducedMotion } from 'framer-motion'

// Spec §8 — named easing curves, as cubic-bezier arrays for framer-motion's `ease` prop.
export const EASE = [0.4, 0, 0.2, 1]
export const EASE_IN_OUT = [0.65, 0, 0.35, 1]
export const EASE_SHEET = [0.32, 0.72, 0, 1]
export const EASE_SHEET_CLOSE = [0.4, 0, 1, 1]
export const SPRING = [0.34, 1.56, 0.64, 1]

// Spec §2 — widget entrance curve (distinct one-off, not one of the 4 named curves above).
export const EASE_ENTRANCE = [0.16, 1, 0.3, 1]

// Spec §8 — durations in seconds (framer-motion's unit).
export const DURATION = {
  widgetEntrance: 0.5,
  screenSlide: 0.34,
  sheetOpen: 0.44,
  sheetClose: 0.26,
  scrimFade: 0.26,
  inlineReveal: 0.32,
  dropdown: 0.24,
  listItemFadeUp: 0.3,
  listItemStagger: 0.075,
  otpDigitPop: 0.18,
  otpVerifiedColor: 0.3,
  otpVerifiedStagger: 0.07,
  wrongCodeShake: 0.4,
  spinner: 1,
  spinnerReduced: 2.4,
  caretRotate: 0.25,
  toggle: 0.25,
  tickPop: 0.4,
  successCirclePop: 0.5,
  successCheckDraw: 0.45,
  successCheckDelay: 0.32,
  successConfettiBurst: 0.9,
  successConfettiDelay: 0.2,
  successTextFadeUpDelay: 0.25,
  successTableFadeUpDelay: 0.35,
  toastFadeRise: 0.3,
  toastVisible: 1.8,
  buttonPress: 0.12,
}

// Spec §8 — screen-forward/back slide: translateX ±18px, 340ms ease-in-out. Header stays still.
export const SCREEN_SLIDE_DISTANCE = 18

// Spec §8 — wrong-code shake: horizontal (-5, 5, -3, 3, 0)px over 400ms.
export const SHAKE_KEYFRAMES = [0, -5, 5, -3, 3, 0]

/**
 * Wraps framer-motion's useReducedMotion(). Spec §8: under reduced motion, disable
 * slides/pops/shakes/bursts (keep instant state changes), draw checks immediately,
 * and slow spinners to 2.4s. Components should branch on this rather than animate
 * blindly, since framer-motion doesn't do this automatically.
 */
export const useReducedMotionPreference = () => useReducedMotion()
